// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2yqSr","file":"styles_file__1t0Xw"};